import React from "react";

import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Dr. Rahul Sharma",

    role: "Dental Clinic",

    review:
      "GrowFlow created a modern website for our clinic and we started receiving appointment inquiries within days. Very professional service.",

    image:
      "https://randomuser.me/api/portraits/men/75.jpg",
  },

  {
    name: "Priya Fitness Studio",

    role: "Gym & Fitness",

    review:
      "The website looks premium and mobile-friendly. WhatsApp inquiries increased significantly after launch.",

    image:
      "https://randomuser.me/api/portraits/women/65.jpg",
  },

  {
    name: "Elite Diagnostic Lab",

    role: "Diagnostic Center",

    review:
      "Excellent support, clean design and fast delivery. GrowFlow helped improve our online presence quickly.",

    image:
      "https://randomuser.me/api/portraits/men/45.jpg",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="py-20 lg:py-28 bg-gradient-to-b from-slate-50 to-white"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">

        {/* Heading */}
        <div className="max-w-3xl mx-auto text-center">

          <p className="text-xs uppercase tracking-[0.22em] font-bold text-[var(--gf-blue)]">
            Testimonials
          </p>

          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.08]">
            Trusted by growing local businesses.
          </h2>

          <p className="mt-5 text-lg text-[var(--gf-text-2)] leading-relaxed">
            Businesses across India trust GrowFlow for modern websites,
            SEO and digital growth solutions.
          </p>
        </div>

        {/* Cards */}
        <div className="mt-16 grid lg:grid-cols-3 gap-7">

          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              className="relative bg-white border border-[var(--gf-border)] rounded-3xl p-8 gf-shadow-soft hover:-translate-y-1 transition-all duration-300"
            >

              {/* Quote */}
              <div className="absolute top-6 right-6 text-[var(--gf-blue)]/10">
                <Quote className="h-14 w-14" />
              </div>

              {/* Stars */}
              <div className="flex items-center gap-1 text-amber-400">
                {[...Array(5)].map((_, starIndex) => (
                  <Star
                    key={starIndex}
                    className="h-4 w-4 fill-current"
                  />
                ))}
              </div>

              {/* Review */}
              <p className="mt-5 text-[15px] text-[var(--gf-secondary)] leading-relaxed relative z-10">
                “{t.review}”
              </p>

              {/* User */}
              <div className="mt-7 flex items-center gap-4">

                <img
                  src={t.image}
                  alt={t.name}
                  className="h-14 w-14 rounded-full object-cover border-2 border-white shadow-md"
                />

                <div>
                  <h4 className="font-semibold text-[var(--gf-primary)]">
                    {t.name}
                  </h4>

                  <p className="text-sm text-[var(--gf-text-2)]">
                    {t.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
